<template>
  <ul class="myFooter t_center grey" v-if="isFooterShow">
    <li v-for="(item, index) in tabbar" @click="toView(item.pathName,item.name)" :key="index">
      <img v-show="$route.name !== item.pathName" :src="'/images/tabbar/'+item.icon+'.png'" align="middle">
      <img v-show="$route.name === item.pathName" :src="'/images/tabbar/'+item.activeIcon+'.png'"
           align="middle">
    
    </li>
  </ul>
</template>

<script>
  import orderApi from '@/axios/order'
  import zhugeObj from '@/assets/js/track'
  export default {
    name: 'footer-com',
    data () {
      return {
        tabbar: [
          { name: '首页', pathName: 'homeIndex', icon: 'home', activeIcon: 'homeActive' },
          { name: '服务', pathName: 'homeListNew', icon: 'service', activeIcon: 'serviceActive' },
          { name: '订单', pathName: 'orderList', icon: 'order', activeIcon: 'orderActive' },
          { name: '我的', pathName: 'myIndex', icon: 'my', activeIcon: 'myActive' }
        ],
        isFooterShow: true
      }
    },
    methods: {
      toView (pathName,name) {
        zhugeObj.track({
          title : '点击底部导航',
          content : {
            '导航名称' : name
          }
        })
        if (pathName === 'orderList') {

          orderApi.getGoodsNumber().then((res)=>{
            let type = 1;
            if(res.waitConfirmNum){
              type = 2;
            }else if(res.maintainingNum){
              type = 3;
            }else if(res.waitDeliveryNum){
              type = 4;
            }

            this.$router.push({
              name: pathName,
              params: {
                type
              }
            })
            return null;
          }).catch(()=>{
            this.$router.push({
              name: pathName,
              params: {
                type : 1
              }
            })
            return;
          })
          // this.$router.push({
          //   name: pathName,
          //   params: {
          //     type : 1
          //   }
          // })
          // return
        } else if(pathName === 'homeListNew') {
          this.$router.push({
            name: pathName,
            params: {
              hideHeaderCom: true
            }
          })
        } else{
          this.$router.push({
            name: pathName
          })
        } 
      }
    },
    watch: {
      '$route' () {
        if(this.$route.meta){
          if(this.$route.name === 'homeListNew') {
            this.isFooterShow = !!this.$route.params.hideHeaderCom
          } else {
            this.isFooterShow = this.$route.meta.isFooterShow
          }
        }else{
          this.isFooterShow = false
        }
        // this.isFooterShow = this.$route.meta?.isFooterShow || false
      }
    }
  }

</script>

<style lang="scss" scoped>
  .myFooter {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 1000;
    width: 100%;
    height: 95px;
    -webkit-transform: translateZ(0);
    padding-top: 12px;
    border-top: 1px rgba(51, 51, 51, 0.1) solid;
    background: $white-color;
    box-shadow:0px -4px 10px 0px rgba(51,51,51,0.1);
    display: flex;
    justify-content: space-around;

    li {
      width: 25%;
      img {
        width: 60px;
        height: 80px;
      }
    }
  }
</style>
